import { publish } from 'helpers/pubsub';
import { UnavailableInspirationsRemovedError } from '.';

const handleInspirationsRemovedError = (inspirationsRemovedError: UnavailableInspirationsRemovedError) => {
    publish(
        'LIST_AGENT/UNAVAILABLE_INSPIRATIONS_REMOVED',
        inspirationsRemovedError.data?.removed_inspirations?.length ?? 1
    );
};

export default handleInspirationsRemovedError;
